import React, { useState } from "react"
import Filed from "./Filed"
import { useLocation } from "react-router-dom";


const MachineRow = ({data}) => {
  const location = useLocation();
  const keyValueList = [
    {
      CDINDEX: "_CDINDEX",
      PAINDEX: "_PAINDEX",
    },
    {
      CDINDEX: "CDINDX",
      PAINDEX: "PAINDX"
    }
  ]

  return (
    <div className="flex">
        <Filed text={`PM${data.HOGIXX ?? ""}`} style={"min-h-14 bg-blue-400 text-white text-2xl content-center align-middle justify-center items-center"}/>
        <div className="flex flex-col">
          <div className="flex flex-grow">
            <Filed text={"CD Index"} style={"bg-blue-400 text-white"}/>
            <DataRow data={data} keyValue={location.pathname === '/month' ? keyValueList[0].CDINDEX : keyValueList[1].CDINDEX}/>
          </div>
          <div className="flex flex-grow">
            <Filed text={"파강 Index"} style={"bg-blue-400 text-white"}/>
            <DataRow data={data} keyValue={location.pathname === '/month' ? keyValueList[0].PAINDEX : keyValueList[1].PAINDEX} />
          </div>
        </div>
      </div>
  )
}

const DataFiled =({text}) => {
  return (
    <div className= "bg-white text-center font-semibold min-w-32 border-r border-b border-black">
      {text ? parseFloat(text).toFixed(2) : ''}
    </div>
  )
}

const DataRow = ({data, keyValue}) => {
  const location = useLocation();
  // 기본 arr 의 length 조절
  const monthArr = () => {
    const arr = new Array(12).fill();
    
    for(let i = 0; i < arr.length; i++) {
      arr[i] = data[`${i + 1}${keyValue}`];
    }
    
    return arr;
  }
  return (
    <>
      {
        location.pathname === "/month" 
        ? monthArr().map((v, index) => {
            return <>
              <DataFiled text={v} key={index}/>
            </>
          })
        : 
          <DataFiled text={data[`${keyValue}`]} />
            
      }
    </>
  )
}

export default MachineRow;